import styled from 'styled-components';
import { IsoLocale } from '@izettle/constants';
import { spacing, breakpoints } from '@izettle/otto';
import { Text, textColorMixin, getLocale, ButtonStyledAnchor } from '@izettle/react';
import { translations } from './.tenko/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "error-page__Container",
  componentId: "zettle__sc-jzy0zf-0"
})(["display:flex;justify-content:center;align-items:center;min-height:65vh;margin-bottom:", ";gap:", ";@media (max-width:", "px){flex-direction:column;gap:", ";}"], spacing.xxLarge, spacing.xLarge, breakpoints.m, spacing.medium);
const Content = /*#__PURE__*/styled.div.withConfig({
  displayName: "error-page__Content",
  componentId: "zettle__sc-jzy0zf-1"
})(["display:flex;flex-direction:column;order:1;@media (max-width:", "px){order:3;}"], breakpoints.m);
const Title = /*#__PURE__*/styled(Text.Huge).withConfig({
  displayName: "error-page__Title",
  componentId: "zettle__sc-jzy0zf-2"
})(["", ";margin-top:0;"], textColorMixin("info"));
const ButtonContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "error-page__ButtonContainer",
  componentId: "zettle__sc-jzy0zf-3"
})(["display:flex;& > *:first-child{margin-right:", ";}"], spacing.small);
const getDogImageUrl = errorCode => {
  switch (errorCode) {
    case "404":
      return "https://cdn.izettle.com/back-office/dog-searching.svg";
    case "500":
    default:
      return "https://cdn.izettle.com/back-office/dog-fixing.svg";
  }
};
const DogImage = /*#__PURE__*/styled.img.attrs(p => ({
  src: getDogImageUrl(p.errorCode)
})).withConfig({
  displayName: "error-page__DogImage",
  componentId: "zettle__sc-jzy0zf-4"
})(["flex-shrink:0;width:50%;max-width:400px;max-height:400px;order:2;@media (max-width:", "px){max-height:250px;width:100%;}"], breakpoints.m);
const TEXT_KEYS = {
  "500": {
    title: "ERROR_PAGE_500_HEADER",
    body: "ERROR_PAGE_500_BODY",
    helpCenterButton: "ERROR_PAGE_HELP_CENTER_BUTTON",
    overviewButton: "ERROR_PAGE_OVERVIEW_BUTTON"
  },
  "404": {
    title: "ERROR_PAGE_404_HEADER",
    body: "ERROR_PAGE_404_BODY",
    helpCenterButton: "ERROR_PAGE_HELP_CENTER_BUTTON",
    overviewButton: "ERROR_PAGE_OVERVIEW_BUTTON"
  }
};
const ErrorPage = _ref => {
  let {
    locale = getLocale(window.navigator.languages) ?? IsoLocale.enGB,
    errorCode = "500"
  } = _ref;
  const texts = translations[locale] ?? translations["en-GB"];
  const keys = TEXT_KEYS[errorCode];
  const text = key =>
  // @ts-expect-error: Temporary until translations are done
  texts[key] ?? translations["en-GB"][key];
  return /*#__PURE__*/jsxs(Container, {
    children: [/*#__PURE__*/jsxs(Content, {
      as: "main",
      children: [/*#__PURE__*/jsx(Title, {
        as: "h1",
        children: text(keys.title)
      }), /*#__PURE__*/jsx(Text.RegularSecondary, {
        children: text(keys.body)
      }), /*#__PURE__*/jsxs(ButtonContainer, {
        children: [errorCode !== "500" && /*#__PURE__*/jsx(ButtonStyledAnchor, {
          variant: "secondary",
          href: "https://zettle.com/help",
          target: "_blank",
          rel: "noopener",
          children: text(keys.helpCenterButton)
        }), /*#__PURE__*/jsx(ButtonStyledAnchor, {
          href: "/",
          children: text(keys.overviewButton)
        })]
      })]
    }), /*#__PURE__*/jsx(DogImage, {
      errorCode: errorCode
      /* hiding the image from screen readers
      since its role is presentation only 
      https://www.w3.org/WAI/tutorials/images/decorative/
      */,
      alt: "",
      role: "presentation"
    })]
  });
};

export { ErrorPage, ErrorPage as default };
//# sourceMappingURL=index.js.map
